module.exports = __webpack_public_path__ + "static/img/mould1-1.d8b48f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/indexEditor/mould/mould1-1.png
// module id = ScOf
// module chunks = 3